/**
 * Mixin for handling delayed loading states in Vue components.
 * Used to prevent flickering of loading indicators during speedy data fetching.
 * It provides methods to start and stop loading with a delay.
 */
export default {
  data() {
    return {
      mixin_loading: false,
      mixin_show_loading: false,
      mixin_loading_timeout: null,
      mixin_loading_delay_ms: 200,
    };
  },

  methods: {
    mixinStartDelayedLoading(delay = this.mixin_loading_delay_ms) {
      this.mixin_loading = true;
      this.mixin_loading_timeout = false;

      if (this.mixin_loading_timeout) {
        clearTimeout(this.mixin_loading_timeout);
      }

      this.mixin_loading_timeout = setTimeout(() => {
        if (this.mixin_loading) {
          this.mixin_show_loading = true;
        }
      }, delay);
    },

    mixinStopDelayedLoading() {
      this.mixin_loading = false;
      this.mixin_show_loading = false;

      if (this.mixin_loading_timeout) {
        clearTimeout(this.mixin_loading_timeout);
        this.mixin_loading_timeout = null;
      }
    },
  },

  beforeDestroy() {
    if (this.mixin_loading_timeout) {
      clearTimeout(this.mixin_loading_timeout);
    }
  },
};
